// extracted by mini-css-extract-plugin
export default {"safe-area-top":"simulated-safe-areas_safe-area-top__6J9h1","safe-area-bottom":"simulated-safe-areas_safe-area-bottom__n3PiW"};